module.exports = __webpack_public_path__ + "img/AS.8e613882.png";